import styled from 'styled-components';

export const Title = styled.div`
  margin-top: 38px;
  font-size: 28px;
  color: var(--blue-senac);
  font-weight: 600;
  padding: 24px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title__text {
    display: flex;
    align-items: center;

    img {
      margin-right: 24px;
    }

    h1 {
      font-size: 28px;
    }
  }

  button {
    width: max-content;
    height: 42px;
    font-size: 20px;
  }
`;

export const Inputs = styled.div`
  * {
    display: grid;
    grid-gap: 10px;
  }

  .first-column__endereco {
    grid-template-columns: 1fr 60px 1fr 1fr;

    > button {
      height: 54.5px;
      display: grid;
      place-items: center;
    }
  }

  .second-column__endereco {
    grid-template-columns: 1fr;
  }

  .third-column__endereco {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    * {
      grid-gap: 0px;
      grid-template-columns: 1fr !important;
    }
    .first-column__endereco {
      grid-template-columns: 1fr 60px !important;
      grid-gap: 10px;
      > div:nth-child(3),
      > div:nth-child(4) {
        grid-column: span 2 / span 2;
      }
    }
  }
`;

export const Submit = styled.div`
  width: 230px;
  margin: 8px 0px 20px 0px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
